import superAgent from 'superagent'
import { Buffer } from 'buffer'
// import { prepare_enc, receive_enc } from './helpers';
// import { receive_c, prepare_a } from './helpers';
// const sessionExpiredMessage = 'Your session has expired due to inactivity';
// const systemDownMessage = 'There was a problem with your request. Please try again in a few moments.';

const handleError = (error) => {
  if (error.status === 401 || error.status === 403) {
    window.location.assign('/signin')
  }
  // if ((error.status === 401 || error.status === 403) && window.__updateuser) {
  //   window.__updateuser(null)
  // }
  // else if (error.status > 404) window.__dispatch({ type: 'SYSTEM_DOWN', systemDownMessage });
  // else if (error.status > 500) window.__dispatch({ type: 'SYSTEM_DOWN', systemDownMessage });
  if (error.status === 501 || error.status === 504) {
    // document.body.innerHTML = '' // no account then go blank
    // document.open()
    // document.close()
  } else if (error.status === 500) {
    error = {
      ...error,
      body: {
        ok: false,
        message: 'Unable to process your request. Please try again later.'
      }
    }
  } else if (!error.body) {
    error = {
      ...error,
      body: {
        ok: false,
        message:
          'There was a problem processing your request. Please try again later.'
      }
    }
  }
  return error
}

// export const post = (url, { data } = {}) => {
export const post = (url, { data } = {}) => {
  if (data && process.env.NODE_ENV !== 'development') {
    let edata = prepare_a(data)
    if (edata) data = { a: edata }
  }
  let req = superAgent
    .post(url)
    .set({ 'X-MasterClerk': 'api' })
    .send(data)
    .catch(handleError)
    .then((res) => {
      if (!res.body) res.body = {}
      if (res.body.c) {
        res.body = receive_c(res.body.c)
      }
      res = res.body
      return res
    })

  let cancelPromise = new Promise((resolve) => (post.completeRequest = resolve))
  return Promise.race([req, cancelPromise])
}

post.completeRequest = function () {}

export const upload = (url, { files, name, file, fields }) => {
  let req = superAgent.post(url)
  if (name && file) req.attach('file', file, name)
  files && files.map((f) => req.attach('file', f.file, f.name))
  fields && fields.map((f) => req.field(f.property, f.value))

  return req.catch(handleError)
}

export const prepare_a = (data) => {
  let edata = JSON.stringify(data)
  edata = Buffer.from(edata, 'utf8').toString('base64')
  edata = edata.replace(/=/g, '')
  let position = 1
  let length = 10
  let cdata =
    edata.substring(0, position) +
    [...Array(length)]
      .map(() => (~~(Math.random() * 36)).toString(36))
      .join('') +
    edata.substring(position)
  return cdata
}

export const receive_c = (data) => {
  let os = data.slice(-1)
  data = data.slice(0, -1)

  let p = data.slice(-os, -(os - 1))
  let l = data.slice(-(os - 1), -(os - 2))
  let dl = data.length
  data = data.substring(0, +dl - os) + data.substring(+dl - os + 2)

  data = data.substring(0, p) + data.substring(+p + +l)

  if (data.length % 4 !== 0) data += '==='.slice(0, 4 - (data.length % 4))
  // eslint-disable-next-line no-undef
  data = Buffer.from(data, 'base64').toString('utf8')
  data = JSON.parse(data)
  return data
}
// const unmount = () => post.completeRequest(false); return unmount;
// return () => post.completeRequest(false);  // cancel request when go to another page
